import {resources} from "../../../../../../../core/models/resource/resources";
import {ColumnPropertyLazySelect} from "../../../../../../../core/types/records-table.types";

export const qualityControlApprovalsResourceType = resources['product-card-quality-control-approvals'];

export const propertyLazySelectApprovalStatus: ColumnPropertyLazySelect = {
  recourseName: 'ProductCardQualityControlApprovalStatus',
  providerType: 'DEFAULT'
}
